import {
  RuntimeChecks,
} from '@ngrx/store';
import {
  RequestParametersService,
} from '@o3r/dynamic-content';
import {
  RequestParams,
} from '@refx/shared-common';
import {
  ApplicationProperties,
} from '../environments/index';

/**
 * Returns the runtime checks configuration for NgRx stores
 *
 * @param environment
 * @returns the runtime checks configuration
 */
export function getRuntimeChecksConfig(environment: ApplicationProperties) {
  return (document: Document, requestParametersService: RequestParametersService): Partial<RuntimeChecks> => {
    const allowParamOverride = JSON.parse(document.body.dataset.bootstrapconfig || '{}').allowParamOverride;
    const allowDynamicConfigEnabled = allowParamOverride && !!requestParametersService.getParameterAsBoolean(RequestParams.allowDynamicConfig);

    return {
      strictActionImmutability: false,
      strictActionSerializability: false,
      strictActionTypeUniqueness: !environment.production,
      strictActionWithinNgZone: !allowDynamicConfigEnabled,
      strictStateImmutability: !environment.production,
      strictStateSerializability: false
    };
  };
}
